import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import Env from '@ridango/core/env';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BannerMessage } from './banners.model';
import { tap } from 'rxjs/operators';

@Injectable()
export class BannersService {
    public bannersLocalStorageKey = `${this.env.APP_NAME}-banners-messages`;

    constructor(
        @Inject('ENV') public env: Env,
        private http: HttpClient,
        private translate: TranslateService
    ) {}

    getBanners(): Observable<{ messages: BannerMessage[] }> {
        const url = `${this.env.WMB?.WMB_PUBLIC_API}/v1/banners`;
        const params = new HttpParams().set('lang', this.translate.currentLang);

        return this.http.get<{ messages: BannerMessage[] }>(url, { params }).pipe(
            tap(({ messages }) => {
                localStorage.setItem(this.bannersLocalStorageKey, JSON.stringify(messages));
            })
        );
    }
}
